module.exports = __webpack_public_path__ + "static/media/ai_history.954bd5fb.svg";